function hideThemeButtons() {
  const { isTeacher } = this.roleInLesson;
  const { displayTopicButtons } = this.buttonsStore;
  if (!isTeacher) {
    displayTopicButtons(false);
  }
}

export default hideThemeButtons;
